import type { Me } from '../components/AppShell';
import { CenterCard, NovaMark } from '../components/ui';
import { useMe } from '../lib/api';
import { VerifyPending } from './AccountPages';
import { ChangePasswordForm, Dashboard } from './Dashboard';
import { Landing } from './Landing';

/** Ana adres: girişli öğretmene panel, diğer herkese tanıtım sayfası. */
export function Home() {
  const { me, error, refresh } = useMe();

  if (error) {
    return (
      <CenterCard title="Sunucuya ulaşılamadı" text={error}>
        <button type="button" className="btn btn-primary" onClick={() => void refresh()}>
          Tekrar dene
        </button>
      </CenterCard>
    );
  }
  if (!me) return <div className="center-screen" aria-busy="true" />;
  if (me.user?.mustChangePassword) {
    return (
      <div className="center-screen">
        <div className="card join-card">
          <NovaMark size={40} />
          <h1>Yeni şifrenizi belirleyin</h1>
          <p className="muted small">Geçici şifreyle giriş yaptınız. Devam etmek için kendi şifrenizi belirleyin.</p>
          <ChangePasswordForm onDone={() => void refresh()} />
        </div>
      </div>
    );
  }
  if (me.user && !me.user.emailVerified) return <VerifyPending user={me.user} onChange={() => void refresh()} />;
  if (me.user && me.account) return <Dashboard me={me as Me} />;
  return <Landing />;
}
